import { connect } from 'react-redux';

import { getPublishedEvent } from '../../actions/LoginPage';
import { getApplicationInfo, onApplicationInfoSubmit, resetApplicationInfoMeta, resetApplicationInfoPage } from '../../actions/ApplicationPage/ApplicationInformationView';
import { getRefereeInfo, onRefereeInfoSubmit, resetRefereeInfoMeta, resetRefereeInfoPage } from '../../actions/ApplicationPage/InformationOfRefereesView';
import { getDocument, onDocumentSubmit, resetDocumentMeta, resetDocumentPage } from '../../actions/ApplicationPage/SupportingDocumentsView';
import { onImportantNotesViewSubmit, resetImportantNotesMeta, resetImportantNotesPage, getEvent } from '../../actions/ApplicationPage/ImportantNotesView';
import { getPersonalParticularByApplicationId, onPersonalParticularSubmit, resetPersonalParticularMeta, resetPersonalParticularPage } from '../../actions/ApplicationPage/PersonalParticularsView';
import { getEducationBackgroundByApplicationId, onEducationBackgroundSubmit, resetEducationBackgroundMeta, resetEducationBackgroundPage } from '../../actions/ApplicationPage/EducationBackgroundView';
import { getApplication, submitApplication, resetApplicationPage, resetApplicationMeta } from '../../actions/ApplicationPage/ReviewAndSubmissionView';
import { getApplicationStatus, onApplicationStatusSubmit, sendPassportForReview, sendItineraryForReview, sendInsuranceForReview, resetApplicationStatusMeta, resetApplicationStatusPage } from '../../actions/ApplicationPage/ApplicationStatusView';
import ApplicationPage from './ApplicationPage';

const mapsStateToProps = state => ({
	loginPageProps: state.loginPageReducer,
	applicationInfoPageProps: state.applicationPage.applicationInfoPageReducer,
	refereeInfoPageProps: state.applicationPage.refereeInfoPageReducer,
	documentPageProps: state.applicationPage.documentPageReducer,
	importantNotePageProps: state.applicationPage.importantNotesPageReducer,
	personalParticularPageProps: state.applicationPage.personalParticularsPageReducer,
	educationBackgroundPageProps: state.applicationPage.educationBackgroundPageReducer,
	reviewAndSubmissionPageProps: state.applicationPage.reviewAndSubmissionPageReducer,
	applicationStatusPageProps: state.applicationPage.applicationStatusPageReducer
});

const mapsDispatchToProps = dispatch => ({
	// Event
	getPublishedEvent() {
		dispatch(getPublishedEvent());
	},

	//Important Notes
	onImportantNotesViewSubmit() {
		dispatch(onImportantNotesViewSubmit());
	},
	getEvent() {
		dispatch(getEvent());
	},
	resetImportantNotesPage() {
		dispatch(resetImportantNotesPage());
	},
	resetImportantNotesMeta() {
		dispatch(resetImportantNotesMeta());
	},


	//Personal Particulars
	getPersonalParticularByApplicationId(id) {
		dispatch(getPersonalParticularByApplicationId(id));
	},
	onPersonalParticularSubmit(options) {
		dispatch(onPersonalParticularSubmit(options));
	},
	resetPersonalParticularMeta() {
		dispatch(resetPersonalParticularMeta());
	},
	resetPersonalParticularPage() {
		dispatch(resetPersonalParticularPage());
	},


	//Educational Background
	getEducationBackgroundByApplicationId(id) {
		dispatch(getEducationBackgroundByApplicationId(id));
	},
	onEducationBackgroundSubmit(options) {
		dispatch(onEducationBackgroundSubmit(options));
	},
	resetEducationBackgroundMeta() {
		dispatch(resetEducationBackgroundMeta());
	},
	resetEducationBackgroundPage() {
		dispatch(resetEducationBackgroundPage());
	},


	//Application Information
	getApplicationInfo(options) {
		dispatch(getApplicationInfo(options));
	},
	onApplicationInfoSubmit(options) {
		dispatch(onApplicationInfoSubmit(options));
	},
	resetApplicationInfoPage() {
		dispatch(resetApplicationInfoPage());
	},
	resetApplicationInfoMeta() {
		dispatch(resetApplicationInfoMeta());
	},


	//Supporting Documents
	getDocument(options) {
		dispatch(getDocument(options));
	},
	onDocumentSubmit(options) {
		dispatch(onDocumentSubmit(options));
	},
	resetDocumentMeta() {
		dispatch(resetDocumentMeta());
	},
	resetDocumentPage() {
		dispatch(resetDocumentPage());
	},


	//Referee Information
	getRefereeInfo(options) {
		dispatch(getRefereeInfo(options));
	},
	onRefereeInfoSubmit(options) {
		dispatch(onRefereeInfoSubmit(options));
	},
	resetRefereeInfoMeta() {
		dispatch(resetRefereeInfoMeta());
	},
	resetRefereeInfoPage() {
		dispatch(resetRefereeInfoPage());
	},


	//Review and Submission
	getApplication(id) {
		dispatch(getApplication(id));
	},
	submitApplication(id) {
		dispatch(submitApplication(id));
	},
	resetApplicationPage() {
		dispatch(resetApplicationPage());
	},
	resetApplicationMeta() {
		dispatch(resetApplicationMeta());
	},


	//Application Status
	getApplicationStatus(options) {
		dispatch(getApplicationStatus(options));
	},
	onApplicationStatusSubmit(options) {
		dispatch(onApplicationStatusSubmit(options));
	},
	sendPassportForReview(options) {
		dispatch(sendPassportForReview(options));
	},
	sendItineraryForReview(options) {
		dispatch(sendItineraryForReview(options));
	},
	sendInsuranceForReview(options) {
		dispatch(sendInsuranceForReview(options));
	},
	resetApplicationStatusMeta() {
		dispatch(resetApplicationStatusMeta());
	},
	resetApplicationStatusPage() {
		dispatch(resetApplicationStatusPage());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(ApplicationPage);
